import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hostnameConversion',
  standalone: false,
})
export class HostnameConversionPipe implements PipeTransform {
  transform(value: string | null): string {
    if (!value) {
      return '';
    }
    return value.toLowerCase().replace(/\./g, '-');
  }
}
